import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { BaseClass, ResFormat } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from 'src/app/auth/login/login.component';
declare var $: any;

import SwiperCore,{Navigation,Pagination,Scrollbar,A11y,Virtual,Zoom,Autoplay,Thumbs,Controller,Swiper} from 'swiper';
import Swal from "sweetalert2";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SharedService } from 'src/app/@shared/services/shared.service';

SwiperCore.use([Navigation,Pagination,Scrollbar,A11y,Virtual,Zoom,Autoplay,Thumbs,Controller]);

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseClass<any> implements OnInit {
  
  public casinoData: any;
  public casinoIntData: any;
  public iCasinoData: any;
  public slotGamesRes: any;
  modalRef?: BsModalRef;
  config = {
    keyboard: false,
    class: 'celebsModal exposureModal modal-sm'
  };
  @ViewChild('staticTabs', { static: false }) staticTabs?: TabsetComponent;
  thumbsSwiper: any;
  swiperConfig: any = {
    slidesPerView: 4,
    spaceBetween: 25,
    autoplay: {
      delay: 2000,
    },
    loop: true,
    breakpoints: {
      640: {
        freemode: true,
        slidesPerView: 4,
        spaceBetween: 10,
      },
      320: {
        freemode: true,
        slidesPerView: 2,
        spaceBetween: 5,
      }
    }
  }
  setThumbsSwiper(swiper: any) {
    this.thumbsSwiper = swiper;
  }
  constructor(
    public service: WebserviceService,
    public router: Router,
    public _common: CommonService,
    private modalService: BsModalService,
    public _shared: SharedService,
  ) { super(document);}

  getServices(): IbaseService<any> {
    return this.service;
  }

  ngOnInit(): void {
    //this.getCasinoData();
    //this.getCasinoIntData();
    this.getData();
  }

  openLogin() {
    this._common.openModalWithComponent({ loginModal: true }, LoginComponent, 'login-modal')
  }

  getData() {
    this.isLoad = true;
    let api = this.isLogin() ? this.api.eventListNew : this.api.eventListNewG;
    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res: ResFormat) => {
        if (res.status == true) {
          // res.data.events = this.UTC_to_Local_timeZone(res.data.events);
          this.setLocalItem('sideMenu', res.data.events);
          this._shared.emitSideMenu(res.data.events);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getCasinoData() {
    let api = this.isLogin() ? this.api.casino1 : this.api.casino1G;
    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.casinoData = res.data;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getiCasinoData() {
    let api = this.isLogin() ? this.api.casinoIntList : this.api.casinoIntListG;
    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.setICasino(res,99995);
          //console.log(this.iCasinoData);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getCasinoIntData() {
    let api = this.isLogin() ? this.api.casinoIntList : this.api.casinoIntListG;
    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.setICasino(res, 99998);
          //console.log(this.casinoIntData);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  setICasino(res: any, casinoId:any) {
    if (res.data.providers) {
      res.data['tables'] = res.data.providers;
    }
    let dt: any[] = [];
    Object.keys(res.data.tables).forEach((key) => {
      Object.keys(res.data.tables[key]).forEach((key1) => {
        Object.keys(res.data.tables[key][key1]).forEach((key2) => {
          dt.push(res.data.tables[key][key1][key2]);
        });
      });
    });
    if(casinoId == '99995'){
      this.iCasinoData = dt;
    }else if(casinoId == '99998'){
      this.casinoIntData = dt;
      this.slotGamesRes = res;
    }
  }
  
  casinoDetail(item: any, casinoId:any) {
    if (this.isLogin()) {
      this.router.navigate([`/casino-detail`, casinoId, item.id]);
    } else {
      this._common.openModalWithComponent({ loginModal: true }, LoginComponent, 'login-modal')
    }
  }
 
  selectTab(tabId: number) {
    if (this.staticTabs?.tabs[tabId]) {
      this.staticTabs.tabs[tabId].active = true;
    }
  }

  sportsbook(e: any) {
    if (!this.isLogin()) {
      this._common.openModalWithComponent({ loginModal: true }, LoginComponent, 'login-modal')
    } else {
      let msg = `<span style="color: #ff0000a3;"> <b>Please note(1 Point = 100 Points) <br> कृपया ध्यान दें(1 अंक = 100 अंक) </b></span><br> Profit & Loss in sports book would be 100 times.It means, if you WIN 1, your Account Statement would be Credited as 100 and similarly if you LOSE 1, your Account Statement would be Debited as 100.`;
      Swal.fire({
        title: 'DO YOU AGREE?',
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate(['/sports_book'])
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      })
    }
  }

  confirmLogin(event_id:any, id: any) {
    if (this.isLogin()) {
      this.router.navigate(['/casino-detail', event_id, id]);
    } else {
      this._common.openModalWithComponent({ loginModal: true }, LoginComponent, 'login-modal')
    }
  }

  redirectCasino(mn_id: any){
    if (this.isLogin()) {
      this.router.navigate(['/casino', mn_id]);
    } else {
      this._common.openModalWithComponent({ loginModal: true }, LoginComponent, 'login-modal')
    }
  }

  playvideo(template: TemplateRef<any>, id:any)
  {
    var name;
    switch(id) { case '1': name='SHAKTI KAPOOR'; break; case '2': name='KARISHMA TANNA'; break; case '3': name='MADALSA SHARMA'; break; case '4': name='ZOYA AFROZ'; break;
          case '6': name='DEEPSHIKHA NAGPAL'; break; case '7': name='AMIT TANDON'; break; case '8': name='AMBIKA RANJANKAR'; break; case '9': name='ADHYAYAN SUMAN'; break;
          case '10': name='RUSHAD RANA'; break; case '11': name='ROOPAL TYAGI'; break; case '12': name='FALAQ NAAZ'; break; case '13': name='SNEHA ULLAL'; break;
          case '14': name='KARAN PATEL'; break; case '15': name='DAISY SHAH'; break; case '16': name='SHAMITA SHETTY'; break; case '17': name='SAPNA CHOUDHARY';  break;
            case '18': name='HINA KHAN';  break; case '19': name='KAINAAT ARORA';  break;
          }
    //$("#celebModal").modal('show');
    this.modalRef = this.modalService.show(template, this.config);      
    $("#vidtitle").text(name);
    $("#datacelb").html('<video controls autoplay="true"  width="100%" onended="runsend('+id+')"><source src="/video/s'+id+'.mp4" type="video/mp4" ></video>')
  }

  stopvideo(){
    $("#datacelb").html('');
    $("#vidtitle").text('');
    this.modalService.hide();
  }

  confirmSport(event_id:any){

    let avail = false;
    if (this.menu.some((item:any) => item.id == event_id)) {
      avail = true;
    }
    if (avail) {
      this.router.navigate([`/exchange_sports`, event_id]);
    } else {
      this._common.commingSoon();
    }
  }
}
